const MISION_T = {
      str_title: "Mision & Vision",
      str_title_1: "Mision",
      str_p_1:  "Become example of compromise and quality in the verification and fulfilment of the Urban Licenses and other acts, making sure to comply wih the current urban norms and eficiency en the processes.",
      str_title_2: "Vision",
      str_p_2: "Be point of reference in the Buacaramanga metropolitan area, as an orgranization of quality in their services and the best satisfaction for the user generating confort and security in the comunity.",
}

export default MISION_T;